import React from 'react'

const IotLeftBody = () => {
  return (
    <div>
      <p className='font-poppin-thin font-medium font-sm text-justify'>From business process optimisation, digital transformation to web/app/IoT development, we assign an industry specific consultant to you to understand your issues and device a plan to help your business grow with technology. We offer a free 1 hour no obligation consultation.</p>
    </div>
  )
}

export default IotLeftBody